import { createAction } from '@reduxjs/toolkit';

export const RESET_ALL_ACTION = 'RESET_ALL';
export const resetAll = createAction(RESET_ALL_ACTION);
